import type { RfqLineDto } from '../api/types'
import { formatDeliveryWindow, formatLineLabel } from './ordersUtils'

type DeliveryBlockProps = {
  date: string | null | undefined
  timeUntil: string | null | undefined
  address: string | null | undefined
}

export const DeliveryBlock = ({ date, timeUntil, address }: DeliveryBlockProps) => {
  const deliveryLine = formatDeliveryWindow(date, timeUntil)
  if (!deliveryLine && !address) {
    return null
  }

  return (
    <div className="echat-panel__block">
      {deliveryLine ? <p className="echat-panel__text">{deliveryLine}</p> : null}
      {address ? <p className="echat-panel__text">Адрес: {address}</p> : null}
    </div>
  )
}

type LineListProps = {
  lines: RfqLineDto[]
  selectable?: boolean
  selectedIds?: number[]
  onToggle?: (lineId: number) => void
}

export const LineList = ({ lines, selectable, selectedIds, onToggle }: LineListProps) => {
  if (lines.length === 0) {
    return null
  }

  if (selectable) {
    return (
      <ul className="echat-lines echat-lines--selectable">
        {lines.map((line) => (
          <li key={line.id}>
            <label className="echat-line-check">
              <input
                type="checkbox"
                checked={selectedIds?.includes(line.id) ?? false}
                onChange={() => onToggle?.(line.id)}
              />
              <span>{formatLineLabel(line)}</span>
            </label>
          </li>
        ))}
      </ul>
    )
  }

  return (
    <ul className="echat-lines">
      {lines.map((line) => (
        <li key={line.id}>{formatLineLabel(line)}</li>
      ))}
    </ul>
  )
}
